<template>
  <b-card>
    <template #header>
      <b-row align-content="between">
        <b-col class="pt-1">
          Preview
        </b-col>
        <b-col cols="3">
          <b-select
            v-model="platform"
            :options="platformOptions"
            size="sm"
            class="float-right" />
        </b-col>
      </b-row>
    </template>
    <b-navbar
      type="dark"
      variant="dark">
      <b-img
        class="mr-2"
        width="56"
        height="30"
        src="/img/mlb-logo.svg"
        alt="MLB" />
      <b-navbar-brand>
        MLB
      </b-navbar-brand>
      <b-navbar-nav>
        <template v-for="item in leftItems">
          <b-btn
            v-if="item.displayType === 'button'"
            :key="item.id"
            class="ml-2"
            :class="dynamicStyles(item)">
            {{ item.label }}
          </b-btn>
          <b-nav-item
            v-else
            :key="item.id"
            :class="dynamicStyles(item)">
            {{ item.label }}
          </b-nav-item>
        </template>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <template v-for="item in rightItems">
          <b-btn
            v-if="item.displayType === 'button'"
            :key="item.id"
            :class="dynamicStyles(item)">
            {{ item.label }}
          </b-btn>
          <b-nav-item
            v-else
            :key="item.id"
            :class="dynamicStyles(item)">
            {{ item.label }}
          </b-nav-item>
        </template>
      </b-navbar-nav>
    </b-navbar>
  </b-card>
</template>

<script>
export default {
  name: "CDMenuPreview",
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    platform: "android",
    platformOptions: [
      {text: "Amazon", value: "amazon"},
      {text: "Android", value: "android"},
      {text: "Chromecast", value: "chromecast"},
      {text: "Playstation", value: "playstation"},
      {text: "Roku", value: "roku"},
      {text: "tvOS", value: "tvos"},
      {text: "Xbox", value: "xbox"},
    ],
  }),
  computed: {
    leftItems() {
      if (!this.config.left) {
        return []
      }
      return this.config.left.filter(it => it.enabled && it[this.platform])
    },
    rightItems() {
      if (!this.config.right) {
        return []
      }
      return this.config.right.filter(it => it.enabled && it[this.platform])
    },
  },
   methods: {
    dynamicStyles(item) {
      return {
              bold: item.selectedState === 'bold',
              underline: item.selectedState === 'underline',
              boldhover: item.hoverState === 'boldhover',
              pill: item.hoverState === 'pill',
      }
    },
  },
}
</script>

<style scoped>
  .bold {
    font-weight: bold;
  }

  .underline {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid white;
    background-color: var(--gray-dark);
  }

  .boldhover:hover {
    font-weight: bold;
  }

  .pill:hover .nav-link,
  .pill:hover {
    color: black;
    border-radius: 100px;
    background-color: white;
    transition: all .75s ease-in-out;
  }
</style>
